import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'proyecto-base-angular';

  ngAfterViewInit(): void {

    setTimeout(() => {
      window.scrollTo({
        top: 100,
      });      
    }, 100);
    setTimeout(() => {
      window.scrollTo({
        top: 0,
      });      
    }, 350);


  }
}
